import { render } from "./FileCheckIcon.vue?vue&type=template&id=2a0713de"
import script from "./FileCheckIcon.vue?vue&type=script&lang=js"
export * from "./FileCheckIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__